import React from 'react'
import { Col, Container, Row, Dropdown } from 'react-bootstrap'
import { UserInfoCard } from '../Components/UserInfoCard'
import { QuickLinkCard } from '../Components/QuickLinkCard'
import { useAuth } from '../contexts/auth';
import { BsQuestionCircle } from "react-icons/bs";
import { Link } from 'react-router-dom';
import '../Pages/Consent/NewConsent.css';

export const Home = () => {
    const { user } = useAuth()
    return (
        <div className="home-container">
            <Container fluid className='h-100'>
                <Row className='h-100 justify-content-center'>
                    <Col md={'8'} className='align-self-center'>
                        <Row className='mb-4'>
                            <Col>
                                <UserInfoCard user={user}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={'6'}>
                                <QuickLinkCard
                                    title={'Give New Consent'}
                                    lightText={true}
                                    customClass={'new-consent-card'}
                                    imagePath={'/images/new-consent.svg'}
                                    redirectTo={'/new-consent'}
                                />
                            </Col>
                            <Col md={'6'}>
                                <QuickLinkCard
                                    title={'Manage Existing Consent'}
                                    lightText={true}
                                    customClass={'manage-consent-card'}
                                    imagePath={'/images/manage-consent.svg'}
                                    redirectTo={'/manage-consent'}
                                    // Added the disabled prop and disabledText prop
                                    disabled={!user?.hasConsents}
                                    disabledText={"You need to create a consent before you can manage it."}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            {/* Help button removed as requested */}
        </div>
    )
}
